import React, { memo } from "react";
import ListFilter from "./ListFilter.js";
import SliderFilter from "./SliderFilter.js";
import DateFilter from "./DateFilter.js";

function getFilterLength(filters, type) {
  if (filters.length === 0) {
    return 0;
  } else {
    if (type === "list") {
      return filters.length;
    } else {
      return 1;
    }
  }
}

const OutputFilter = (props) => {
  if (props.filterType.type === "list") {
    return (
      <ListFilter
        matchingFilterString={props.matchingFilterString}
        updateFilters={props.updateFilters}
        filterType={props.filterType}
      />
    );
  } else if (props.filterType.type === "number") {
    return (
      <SliderFilter
        matchingFilterString={props.matchingFilterString}
        updateFilters={props.updateFilters}
        filterType={props.filterType}
        activeFilters={props.matchingFilters}
      />
    );
  } else {
    return (
      <DateFilter
        matchingFilterString={props.matchingFilterString}
        updateFilters={props.updateFilters}
        minDate={props.minDate}
        maxDate={props.maxDate}
        filterType={props.filterType}
      />
    );
  }
};

function SideBarFilter(props) {
  return (
    <div
      style={{
        cursor: "pointer",
        color: "#333333",
        borderBottom: "1px solid #cccccc",
        marginBottom: 15,
      }}
    >
      <div
        onClick={() => {
          props.collapse(!props.collapsed);
        }}
        style={{
          fontWeight: props.collapsed ? "500" : "700",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          fontSize: 16,
          marginBottom: 10,
        }}
      >
        {props.filterType.text}
        {props.collapsed ? (
          <i
            aria-hidden
            style={{ marginLeft: 10, color: "var(--primary-color-600)" }}
            className="fas fa-chevron-down"
          />
        ) : (
          <i
            aria-hidden
            style={{ marginLeft: 10, color: "var(--primary-color-600)" }}
            className="fas fa-chevron-up"
          />
        )}
        {props.matchingFilterString.length !== 0 && (
          <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            <div
              style={{
                width: 22,
                height: 22,
                paddingLeft: 1,
                borderRadius: 11,
                backgroundColor: "var(--primary-color-600)",
                color: "#fff",
                textAlign: "center",
                fontWeight: 600,
                fontSize: 14,
                alignItems: "center",
                justifyContent: "center",
                lineHeight: "22px",
              }}
            >
              {getFilterLength(
                props.matchingFilterString,
                props.filterType.type
              )}
            </div>
          </div>
        )}
      </div>
      <div style={{ margin: "0px -10px" }}>
        {!props.collapsed && (
          <div style={{ padding: "0px 10px 40px 10px" }}>
            <OutputFilter {...props} />
            <div
              onClick={() => {
                props.updateFilters([], props.filterType.data);
              }}
            >
              <i
                style={{ fontSize: 16, marginRight: 5 }}
                aria-hidden
                className="far fa-trash-alt"
              ></i>
              <span style={{ fontSize: 14, fontWeight: 600 }}>
                Clear Filter
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default memo(SideBarFilter);
